import React, { type HTMLAttributes } from 'react';
import styled, { css } from 'styled-components';
import { BorderRadiusSmall, ColorNeutralWhite, Spacing4, Spacing8 } from 'autogen/design-tokens/tokens';
import type { sizeType } from './types';

function getSizeStyling(size?: sizeType) {
    switch (size) {
        case 'sm':
            return css`
                width: 40px;
                height: 24px;
                padding: ${Spacing4};
            `;
        case 'lg':
        default:
            return css`
                width: 60px;
                height: 40px;
                padding: ${Spacing8};
            `;
    }
}

const Wrapper = styled.div<{ size: sizeType }>`
    ${({ size }) => getSizeStyling(size)}
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${ColorNeutralWhite};
    border-radius: ${BorderRadiusSmall};

    svg {
        width: 100%;
        height: auto;
        max-height: 100%;
    }
`;

interface IIcon extends HTMLAttributes<HTMLDivElement> {
    size?: sizeType;
}

export default function IconCard({ size = 'lg', ...restProps }: IIcon): JSX.Element {
    const { children } = restProps;
    return (
        <Wrapper size={size} {...restProps}>
            {children}
        </Wrapper>
    );
}
